<template>
  <div class="page-wrapper">
    <div class="app-card-lg policy-card">
      <h1 class="policy-title">用户协议</h1>
      <div class="policy-content">
        <p>更新时间：2026年9月11日</p>
        <p>生效时间：2026年9月11日</p>
        <p>
          <strong>【重要提示】</strong>
          欢迎您使用「EATing创意融合轻食」相关服务（含微信小程序、网站及配套管理系统，以下统称“本服务”）。
          请您在注册、登录、下单或使用本服务前，认真阅读并充分理解本《用户协议》（以下简称“本协议”）。
          您点击同意或以实际使用行为使用本服务，即视为已阅读并同意本协议全部内容。
        </p>

        <h2>一、协议主体、角色与适用范围</h2>
        <ul>
          <li>
            <strong>协议主体：</strong>
            本协议由您与实际运营方共同缔结。
            实际运营方：温岭市城西宜汀餐饮店（个体工商户）（对外品牌名称：EATing创意融合轻食，以下简称“运营方”）。
            运营方负责门店自运营，包括但不限于菜品供应、价格与活动规则、订单接单与履约、配送/自取服务、售后处理及客户服务。
          </li>
          <li>
            <strong>开发与技术支持单位：</strong>
            温岭市太平迅驰软件开发工作室（个体工商户）（以下简称“开发单位”或“技术支持方”）。
            开发单位仅提供软件开发、系统技术支持与维护，不参与门店日常运营，不作为您的交易相对方，不就食品质量、经营决策、配送结果、营销活动及资金结算向您承担经营者责任。
          </li>
          <li>
            <strong>适用范围：</strong>
            本协议适用于本服务的注册登录、浏览下单、随心订、积分/兑换券、团购券核销相关展示与使用、支付、地址管理、门店选择、会员功能、售后客服等。
          </li>
        </ul>

        <h2>二、账号注册与使用规范</h2>
        <ul>
          <li>您应提供真实、准确、完整的信息，并及时更新手机号、收货信息等关键资料。</li>
          <li>您应妥善保管账号、验证码及登录凭证，不得出借、出租、转让账号。</li>
          <li>因您保管不善、授权他人使用或自身原因导致的损失，由您依法承担相应责任。</li>
          <li>如发现账号异常，请立即联系运营方客服处理。</li>
        </ul>

        <h2>三、服务内容与业务规则</h2>
        <h3>（一）订餐与普通订单</h3>
        <ul>
          <li>您可浏览商品、选择规格与数量并提交订单。</li>
          <li>订单信息以提交时页面展示及系统记录为准；请在提交前仔细核对商品、金额、门店、取餐/配送方式及联系方式。</li>
        </ul>
        <h3>（二）随心订等周期性服务</h3>
        <ul>
          <li>随心订属于周期性餐饮服务，具体周期、餐次、份数、价格、延期与变更规则以页面展示为准。</li>
          <li>您按页面规则申请延期、暂停、恢复或取消的，以系统最新计划及运营方确认为准。</li>
        </ul>
        <h3>（三）优惠券、兑换券与团购权益</h3>
        <ul>
          <li>券类权益的领取、使用门槛、有效期、适用范围以券面规则及下单页说明为准。</li>
          <li>您不得通过刷券、倒卖、作弊等方式牟利；一经发现，运营方有权取消权益、限制功能并依法追责。</li>
        </ul>
        <h3>（四）门店、配送与自取</h3>
        <ul>
          <li>您应根据页面提示选择门店，并准确填写收货/联系信息。</li>
          <li>因地址错误、电话错误、无法联系等导致无法履约的，相关责任由信息提交方承担。</li>
          <li>配送时效可能受天气、交通、订单高峰等因素影响，运营方将尽力履约并及时沟通。</li>
        </ul>

        <h2>四、支付、退款与资金说明</h2>
        <ul>
          <li>支付由持牌支付机构处理；本服务不直接保存银行卡号、支付密码等敏感支付信息。</li>
          <li>退款、售后规则依据订单状态、商品属性、页面规则及运营方通知执行。</li>
          <li>
            开发单位不直接收取您的餐费，不参与运营方与您之间的资金收付与结算，不对交易资金纠纷承担经营责任。
          </li>
        </ul>

        <h2>五、用户行为规范</h2>
        <p>您承诺不得：</p>
        <ul>
          <li>实施虚假下单、恶意退款、虚假投诉、刷单刷券等扰乱经营秩序的行为；</li>
          <li>攻击、入侵、干扰本服务系统，或未经授权抓取数据；</li>
          <li>发布违法违规、侵权或违背公序良俗的内容；</li>
          <li>利用本服务从事任何违法活动。</li>
        </ul>
        <p>
          违反上述规范的，运营方有权采取限制功能、暂停或终止服务等措施，并保留依法追责的权利。
        </p>

        <h2>六、知识产权</h2>
        <p>
          本服务所含软件、界面、文案、标识等，其权利归权利人依法享有。未经许可，您不得复制、修改、传播或用于商业目的。
        </p>

        <h2>七、免责声明与责任划分</h2>
        <ul>
          <li>运营方作为餐饮服务提供者，对门店经营、食品安全、订单履约、售后服务承担相应法律责任。</li>
          <li>
            开发单位仅就软件开发与系统技术支持、维护承担责任，不对下列事项承担责任：经营决策、菜品质量与口味、价格与促销、配送结果、人力排班、线下服务及资金结算纠纷等。
          </li>
          <li>
            因不可抗力、第三方服务故障、通信中断、系统维护升级等导致的暂时性服务异常，将依法处理并尽快恢复。
          </li>
        </ul>

        <h2>八、个人信息保护</h2>
        <p>
          我们将按照法律法规及《用户隐私政策》处理您的个人信息。详细规则请参阅《用户隐私政策》。
        </p>

        <h2>九、协议变更、终止与通知</h2>
        <ul>
          <li>运营方可根据法律法规及业务变化更新本协议，并通过页面公告、弹窗等方式提示。</li>
          <li>如您不同意更新内容，请停止使用本服务；继续使用视为接受更新后的协议。</li>
          <li>您可申请注销账号或停止使用服务；运营方亦可在您严重违约时限制或终止服务。</li>
        </ul>

        <h2>十、法律适用与争议解决</h2>
        <ul>
          <li>本协议适用中华人民共和国法律（不含冲突法规则）。</li>
          <li>
            因本协议产生的争议，双方应先行协商；协商不成的，提交运营方所在地有管辖权的人民法院诉讼解决。
          </li>
        </ul>

        <h2>十一、联系方式</h2>
        <ul>
          <li>
            <strong>运营方：</strong>
            温岭市城西宜汀餐饮店（个体工商户）；品牌：EATing创意融合轻食；联系电话：13958677072。
            职责：门店自运营、餐饮服务、订单与售后等日常经营。
          </li>
          <li>
            <strong>开发与技术支持单位：</strong>
            温岭市太平迅驰软件开发工作室（个体工商户）；电子邮箱：wenlingxunchi@163.com。
            职责：软件开发、系统技术支持与维护；不包含门店日常运营。
          </li>
        </ul>
      </div>
      <div class="policy-footer">
        <el-button class="btn-primary" @click="$router.push('/login')">返回登录页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserAgreement'
}
</script>

<style scoped>
.page-wrapper {
  padding: 24px;
  min-height: 100vh;
  background: var(--page-bg);
  display: flex;
  justify-content: center;
}

.policy-card {
  max-width: 960px;
}

.policy-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-title);
  text-align: center;
  margin-bottom: 16px;
}

.policy-content {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-body);
}

.policy-content h2 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-title);
  margin-top: 16px;
  margin-bottom: 8px;
}

.policy-content h3 {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-subtitle);
  margin-top: 12px;
  margin-bottom: 4px;
}

.policy-footer {
  margin-top: 24px;
  text-align: center;
}
</style>
